module.exports = __webpack_public_path__ + "static/media/lheves.25c6d2fa.jpg";